import React from 'react'
import classnames from 'classnames'

const OpenBoxSVG = ({ className }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      className={classnames('dealmed-icon', className)}
      aria-hidden={true}
      focusable={false}
    >
      <path d="M26.608 12.26l-1.717-3.426c-0.133-0.267-0.403-0.317-0.557-0.297l-8.336 1.063-8.339-1.063c-0.153-0.020-0.42 0.030-0.553 0.297l-1.717 3.426c-0.153 0.307 0.010 0.673 0.337 0.767l1.74 0.497v7.043c0 0.49 0.333 0.917 0.807 1.033l7.206 1.803c0.2 0.050 0.58 0.113 1.033 0l7.213-1.803c0.473-0.12 0.807-0.547 0.807-1.033v-7.043l1.737-0.497c0.33-0.093 0.49-0.46 0.34-0.767zM8.199 10.22l5.16 0.657-1.373 2.277-4.6-1.313 0.813-1.62zM9.066 13.98l3.26 0.93c0.267 0.077 0.507-0.060 0.617-0.243l2.257-3.74v10.756l-6.133-1.533v-6.17zM22.932 20.15l-6.133 1.533v-10.756l2.257 3.743c0.11 0.183 0.353 0.32 0.617 0.243l3.26-0.93v6.166zM20.009 13.154l-1.373-2.277 5.163-0.657 0.81 1.62-4.6 1.313z"></path>
    </svg>
  )
}

export default OpenBoxSVG
